import apiFetch from '../../apiFetch'

export default function (id, token) {
  return apiFetch({endPoint: `Microbiologia/deleteMicrobiologia`, method: 'POST', body: {id}, token: token})
}
